import React from 'react';
import { withFormsy } from 'formsy-react';
import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

import { type FilterItemBaseProps } from '../FilterItemManager';

const StyledTextField = styled(TextField)(({ theme }) => ({
	'& > .MuiOutlinedInput-root > .MuiOutlinedInput-input': {
		paddingTop: 12,
		paddingBottom: 12
	}
}));

function TextFilterItem(props: FilterItemBaseProps<string>) {
	const isDisabled = !!props.defaultValue;

	function handleChange(event) {
		props.sendChange(event.target.value);
	}

	return (
		<StyledTextField
			className={props.className}
			name={props.name}
			variant="outlined"
			size="small"
			fullWidth
			autoComplete="off"
			placeholder={props.placeholder}
			slotProps={{ inputLabel: { shrink: true } }}
			defaultValue={props.defaultValue || props.value}
			disabled={isDisabled}
			onBlur={handleChange}
		/>
	);
}

export default React.memo(withFormsy(TextFilterItem));
